import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const fadeOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to   { opacity: 0; transform: translateY(-6px); }
`;

export const RotatingText = styled.span`
  display: inline-block;
  animation: ${({ $fading }) => ($fading ? fadeOut : fadeIn)} 0.4s ease forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;